module.exports = __webpack_public_path__ + "static/homepage-hero-df35539cc7ba0bdab6d146eea0d221c2.jpg";